import React from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './CandidateCard.scss';
import {
  ELECTION_STATUS_MAPPING,
  IMAGE_URL,
  IMAGE_VERSION,
} from '../../../../constants';

const CandidateCard = ({ candidate, index, isMiniCard = false }) =>
  !isMiniCard ? (
    <div className={s.candidate} key={index}>
      <div className={s.partyName} style={{ color: candidate.cc }}>
        {candidate.an}
      </div>
      <div className={s.imageWrap}>
        <div className={s.content}>
          <ImageV2
            src={`${IMAGE_URL}msid-${
              candidate.img ? candidate.img : '69347424'
            },imgsize-${IMAGE_VERSION?.version}.cms`}
            alt={candidate.cn}
          />
        </div>
        <div
          className={`${s.battleInfo} ${
            s[ELECTION_STATUS_MAPPING[candidate.cs]]
          }`}
        >
          {ELECTION_STATUS_MAPPING[candidate.cs]
            ? `${ELECTION_STATUS_MAPPING[candidate.cs]}`
            : ''}
        </div>
      </div>
      <div className={s.details}>
        <div className={s.detailsBtm}>
          <p className={s.candidateName}>{candidate.cn}</p>
          <p className={s.candidateCnsName}>{candidate.cns_name}</p>
          {candidate.sn && <p className={s.candidateCnsName}>{candidate.sn}</p>}
        </div>
      </div>
    </div>
  ) : (
    <div className={`${s.candidate} ${s.miniCard}`} key={index}>
      <div className={s.candidatePartyLogo}>
        <div className={s.partyLogo}>
          <ImageV2 src={`${IMAGE_URL}${candidate.lg}.cms`} alt={candidate.cn} />
        </div>
        <div className={s.miniCardCandiInfo}>
          <div className={s.candidateName}>{candidate.cn}</div>
          <div
            className={`${s.battleInfo} ${
              s[ELECTION_STATUS_MAPPING[candidate.cs]]
            }`}
          >
            {ELECTION_STATUS_MAPPING[candidate.cs]
              ? `${ELECTION_STATUS_MAPPING[candidate.cs]}`
              : ''}
          </div>
        </div>
      </div>
      <div className={s.detailsBtm}>
        <p className={s.partyName} style={{ color: candidate.cc }}>
          {candidate.an}
        </p>
        <p className={s.candidateCnsName}>
          {candidate.cns_name} {candidate.sn ? ` | ${candidate.sn}` : ''}
        </p>
      </div>
    </div>
  );

export default CandidateCard;
